import ActionConstants from "../action-constants"
import Action from "./Action";

class CartListActions extends Action {
    static getDiscountAmount(data) {
        return {
            type: ActionConstants.GET_DISCOUNT_AMOUNT,
            payload: {
                data
            }
        }
    }
}

export default CartListActions;